"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testDataCreator = void 0;
var tslib_1 = require("tslib");
var testDataCreator = function (defaults) {
    return function (partial) {
        if (partial === void 0) { partial = {}; }
        // tslint:disable-next-line:ban-types
        var objDefaults = (typeof defaults === 'function' ? defaults() : defaults);
        var objPartial = partial;
        // tslint:disable-next-line:no-object-literal-type-assertion
        var ret = tslib_1.__assign(tslib_1.__assign({}, objDefaults), objPartial);
        return ret;
    };
};
exports.testDataCreator = testDataCreator;
//# sourceMappingURL=index.js.map